// src/features/dashboard/services/Employee/employeeLoggedHours.service.ts

import api from '../../../../api/apiService';
import { ENDPOINTS } from '../../../../api/endpoints';

import {
  LoggedHoursKpiRequest,
  LoggedHoursKpiResponse,
  SessionLogRequest,
  SessionLogResponse,
  WtdLoggedRequest,
  WtdLoggedResponse,
  Logged30DayRequest,
  Logged30DayResponse,
  TimeSplitRequest,
  TimeSplitResponse,
  MeVsTeamLoggedRequest,
  MeVsTeamLoggedResponse,
  DailyLogRequest,
  DailyLogResponse,
  HourlyLoggedRequest,
  HourlyLoggedResponse,
} from '../../types/Employee/employeeLoggedHours.types';

/* ==========================================================
 * KPI
 * ========================================================== */

export const getLoggedHoursKpi = async (
  payload: LoggedHoursKpiRequest,
): Promise<LoggedHoursKpiResponse> => {
  const { data } = await api.post<LoggedHoursKpiResponse>(
    ENDPOINTS.LOGGED_HOURS_KPI,
    payload,
  );

  console.log("KPI_Service_calls",data);
  return data;
};

/* ==========================================================
 * Session Log
 * ========================================================== */

export const getSessionLog = async (
  payload: SessionLogRequest,
): Promise<SessionLogResponse[]> => {
  const { data } = await api.post<SessionLogResponse[]>(
    ENDPOINTS.LOGGED_HOURS_SESSION_LOG,
    payload,
  );

  return data;
};

/* ==========================================================
 * WTD Logged
 * ========================================================== */

export const getWtdLogged = async (
  payload: WtdLoggedRequest,
): Promise<WtdLoggedResponse[]> => {
  const { data } = await api.post<WtdLoggedResponse[]>(
    ENDPOINTS.LOGGED_HOURS_WTD,
    payload,
  );

  return data;
};

/* ==========================================================
 * 30 Day Logged
 * ========================================================== */

export const getThirtyDayLogged = async (
  payload: Logged30DayRequest,
): Promise<Logged30DayResponse> => {
  const { data } = await api.post<Logged30DayResponse>(
    ENDPOINTS.LOGGED_HOURS_30DAY,
    payload,
  );

  return data;
};

/* ==========================================================
 * Time Split
 * ========================================================== */

export const getTimeSplit = async (
  payload: TimeSplitRequest,
): Promise<TimeSplitResponse[]> => {
  const { data } = await api.post<TimeSplitResponse[]>(
    ENDPOINTS.LOGGED_HOURS_TIME_SPLIT,
    payload,
  );

  return data;
};

/* ==========================================================
 * Me vs Team Logged
 * ========================================================== */

export const getMeVsTeamLogged = async (
  payload: MeVsTeamLoggedRequest,
): Promise<MeVsTeamLoggedResponse> => {
  const { data } = await api.post<MeVsTeamLoggedResponse>(
    ENDPOINTS.LOGGED_HOURS_ME_VS_TEAM,
    payload,
  );

  return data;
};

/* ==========================================================
 * Daily Log
 * ========================================================== */

export const getDailyLog = async (
  payload: DailyLogRequest,
): Promise<DailyLogResponse> => {
  const { data } = await api.post<DailyLogResponse>(
    ENDPOINTS.LOGGED_HOURS_DAILY_LOG,
    payload,
  );

  return data;
};

/* ==========================================================
 * Hourly Logged
 * ========================================================== */

export const getHourlyLogged = async (
  payload: HourlyLoggedRequest,
): Promise<HourlyLoggedResponse> => {
  const { data } = await api.post<HourlyLoggedResponse>(
    ENDPOINTS.LOGGED_HOURS_HOURLY,
    payload,
  );

  return data;
};